import { Component } from '@angular/core';
import { Settings } from 'src/app/services/settings';
import { UserService } from 'src/app/services/user.service';

@Component({
	selector: 'app-unassigned-request-emails',
	templateUrl: './unassigned-request-emails.component.html',
	styleUrls: ['./unassigned-request-emails.component.css']
})
export class UnassignedRequestEmailsComponent {
	public enabledList: any;
	public selectedValue: string;
	public settingsRecord: any;
	public currentRunState: string;
	public visibleModify: boolean = false;
	constructor(public settingsService: UserService) {
		this.enabledList = [];
		this.enabledList.push({ id: 'true', description: 'Enabled' });
		this.enabledList.push({ id: 'false', description: 'Disabled' });
	}

	ngOnInit() {
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_UNASSIGNED_REQUEST_EMAILS', "WRITE")) {
			this.visibleModify = true;
		}

		this.settingsRecord = Settings.getInstance().getGeneralSettingByKey('unmatchedemailservice');

		if (this.settingsRecord && this.settingsRecord.value !== undefined) {
			this.selectedValue = this.settingsRecord.value;
			this.currentRunState = this.displayCurrentState(this.selectedValue);
		} else {
			console.warn("Setting 'unmatchedemailservice' not found or value is null");
			this.selectedValue = 'false'; // fallback default
			this.currentRunState = this.displayCurrentState(this.selectedValue);
		}
	}



	public updateUnassignedEmailStatus(val: any): void {

		this.settingsRecord.value = val;
		this.settingsService.createUpdateSetting(this.settingsRecord).subscribe(
			(result) => {
				this.currentRunState = this.displayCurrentState(this.selectedValue);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Updating survey email service setting');
			});
	}
	public displayCurrentState(runningState: string): string {

		if (runningState === "true") {
			return 'Running ...';
		}

		return 'Suspended ... ';
	}
}
